import {
  SET_IS_LOADING,
  SET_SELF_SERVICE_USERS,
  CLEAR_SELF_SERVICE_USERS,
  SET_IS_SETTINGS_LOADING,
  SET_SELF_SERVICE_SETTINGS,
  CLEAR_SELF_SERVICE_SETTINGS
} from './constants';

const defaultSettings = {
  pathLogo: null,
  urlLogo: null,
  primaryColor: null,
  secondaryColor: null,
  darkModeEnabled: null,
  automaticPaymentExit: null
}

const initialState = {
  list: [],
  total: null,
  isLoading: false,
  isSettingsLoading: false,
  settings: defaultSettings
}

const selfServiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_IS_LOADING: {
      return {
        ...state,
        isLoading: action.payload
      }
    }
    case SET_IS_SETTINGS_LOADING: {
      return {
        ...state,
        isSettingsLoading: action.payload
      }
    }
    case SET_SELF_SERVICE_USERS: {
      return {
        ...state,
        list: action.payload?.content || [],
        total: action.payload?.total
      }
    }
    case CLEAR_SELF_SERVICE_USERS: {
      return initialState;
    }
    case SET_SELF_SERVICE_SETTINGS: {
      return {
        ...state,
        settings: {
          ...state.settings,
          pathLogo: action.payload?.pathLogo,
          urlLogo: action.payload?.urlLogo,
          primaryColor: action.payload?.primaryColor,
          secondaryColor: action.payload?.secondaryColor,
          darkModeEnabled: action.payload?.darkModeEnabled,
          automaticPaymentExit: action.payload?.automaticPaymentExit
        }
      }
    }
    case CLEAR_SELF_SERVICE_SETTINGS: {
      return {
        ...state,
        settings: defaultSettings
      }
    }
    default: {
      return state;
    }
  }
}

export default selfServiceReducer;